import styled from 'styled-components';

import { ActionButton, InlineButton } from 'src/commons/components/Button';
import SubHeading from 'src/commons/components/SubHeading';
import {
  colors,
  CARD_BREAKPOINT,
  MOBILE_BREAKPOINT,
} from 'src/commons/constants';

export const AutoPaySubHeading = styled(SubHeading)`
  min-height: 3.25rem;
  max-width: 26.625rem;
  margin: 1.1875rem 0 0;
  font-size: 1rem;
  line-height: 1.5;
  text-align: center;
  color: ${colors.TEXT_PRIMARY};
  @media (max-width: ${CARD_BREAKPOINT}) {
    padding: 0 2.5rem;
  }
  @media (max-width: ${MOBILE_BREAKPOINT}) {
    margin: 0.5625rem 0 0.5rem;
    padding: 0;
  }
`;

export const AutoPayActionsContainer = styled.div`
  width: 100%;
  max-width: 25rem;
  margin: 0 0 4.375rem;
  display: flex;
  flex-flow: column nowrap;
  align-items: center;
  @media (max-width: ${MOBILE_BREAKPOINT}) {
    margin: 0 0 3.375rem;
  }
`;

export const AutoPayAcceptButton = styled(ActionButton)`
  margin: 0 0 1.5rem;
`;

export const DeclineButton = styled(InlineButton)`
  max-width: 23rem;
  padding: 0.0625rem;
  color: ${colors.TEXT_ANCHOR};
  text-decoration: none;
  &:hover {
    text-decoration: underline;
  }
  &:focus:not(:hover, :focus-visible) {
    text-decoration: none;
    outline: none;
  }
  &:focus-visible {
    text-decoration: none;
    outline: 0.125rem solid ${colors.UI_SECONDARY_ACCENT};
    border-radius: 0.125rem;
  }
  @media (max-width: ${MOBILE_BREAKPOINT}) {
    max-width: 17.25rem;
  }
`;
